import { isProductComingSoon } from '../../comingSoon/scripts';

function applyComingSoonWishlistCta(element) {
  element.querySelector('[data-add-to-cart]')?.remove();

  const submitItem = element.querySelector('.product__submit__item');
  if (!submitItem) return;

  const disabledBtn = document.createElement('button');
  disabledBtn.type = 'button';
  disabledBtn.className = 'btn btn--primary btn--solid sold-out-button';
  disabledBtn.disabled = true;
  disabledBtn.innerHTML = `<span class="btn__text">${window.theme?.strings?.comingSoon || 'Coming soon'}</span>`;
  submitItem.appendChild(disabledBtn);

  element.querySelector('[data-product-form]')?.addEventListener('submit', (event) => {
    event.preventDefault();
  });
}

const sectionCheck = document.querySelector('.wishlist-section');

if (sectionCheck) {
  function fireWhenReady() {
    if (typeof SmartWishlistMain != 'undefined') {
      wishlistInit();
    } else {
      setTimeout(fireWhenReady, 100);
    }
  }
  fireWhenReady();
}

function wishlistInit() {
  //This jQuery based code fetches the contents of Express Wishlist (unregistered users)
  let customerid = SWGetCustomerWishlistId();
  let wishlistid = customerid !== 0 ? customerid : SWGetExpressWishlistId();
  let idParam = customerid !== 0 ? `customerid` : `wishlistid`;

  jQuery.ajax({
    url: `/a/wishlist?type=api&${ idParam }=${ wishlistid }&version=1`,
    dataType: 'json',
    cache: false,
    success: function(data) {
      if (data.count < 1) {
        document.querySelector('.wishlist__empty').removeAttribute('hidden');
      } else {
        displayItems(data.items);
        document.querySelector('.grid').removeAttribute('hidden');
        //copy wishlist link to clipboard
        const shareWishlistButtons =
          document.querySelectorAll('.wishlist-share');
        shareWishlistButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const wishlistURL = `${ window.location.origin }/a/wishlist/${ wishlistid }`;
            navigator.clipboard.writeText(wishlistURL).then(() => {
              btn.innerText = btn.dataset.text;
            });
          });
        });
      }
    },
  });
}

function buildSizeDropdown(productID, variantID, variantTitle, variants) {
  let targets = document.querySelectorAll(
    `[data-product-id='${ productID }'] .select-items`
  );
  variants.forEach((variant) => {
    if (variant.available) {
      let opt = document.createElement('div');
      opt.dataset.variant = variant.id;
      opt.innerHTML = variant.title;
      targets.forEach((target) => {
        target.appendChild(opt.cloneNode(true));
      });
    }
  });
}

// Function to close all select boxes except the current one:
function closeAllSelect(elmnt) {
  let selects = document.getElementsByClassName('select-items');
  let selectedDivs = document.getElementsByClassName('select-selected');
  Array.from(selectedDivs).forEach((selectedDiv) => {
    if (elmnt != selectedDiv) {
      selectedDiv.classList.remove('select-arrow-active');
    }
  });
  Array.from(selects).forEach((select) => {
    if (elmnt != select.previousSibling) {
      select.classList.add('select-hide');
    }
  });
}

async function displayItems(items) {
  let temp = document.getElementById('wishlist-item-template');
  if (!temp) {
    console.error('Wishlist item template not found');
    return;
  }
  let itemx = temp.content.querySelector('div');

  if (!itemx) {
    console.error('Wishlist item template content is empty or missing div');
    return;
  }


  // Fetch product data for all items in parallel and append variants to each item
  await Promise.all(
    items.map(async (item) => {
      try {
        const res = await fetch(window.Shopify.routes.root + `products/${ item.handle }.js`);
        if (!res.ok) throw new Error('Failed to fetch product data');
        const productData = await res.json();
        item.variants = productData.variants || [];
        item.tags = productData.tags || [];
        item.variant_price = productData.variants[0].price / 100;
      } catch (err) {
        item.variants = [];
        console.error(`Failed to fetch variants for ${ item.handle }:`, err);
      }
    })
  );


  items.forEach((item) => {

    let productID = item.id;
    let productTitle = item.title;
    let productPrice = item.variant_price;
    let variantID = item.variant_id;
    let variantTitle = item.variant_title;
    let productHandle = item.handle;
    let firstImage = item.image;


    newElement = document.importNode(itemx, true);
    const btn = newElement.querySelector('.product__submit__item .btn');
    newElement.querySelector('.product-item__title').innerHTML = productTitle;
    newElement.querySelector('.smartwishlist').dataset.product = productID;
    newElement.querySelector('.custom-select').dataset.productId = productID;
    newElement.querySelector('.product-cta').dataset.productId = productID;
    if (btn) {
      btn.dataset.productId = productID;
      btn.dataset.variantId = variantID;
    }
    newElement.querySelector('.smartwishlist').dataset.variant = variantID;
    newElement.querySelectorAll('.product-link').forEach((link) => {
      link.setAttribute('href', `/products/${ productHandle }`);
    });
    newElement
      .querySelector('.wishlist-thumbnail')
      .setAttribute('src', firstImage);

    let srcset = newElement
      .querySelector('.wishlist-thumbnail')
      .getAttribute('srcset');
    srcset = srcset.replaceAll('${firstImage}', firstImage);
    newElement
      .querySelector('.wishlist-thumbnail')
      .setAttribute('srcset', srcset);
    newElement.querySelector('.money').innerHTML =
      window.Shopify.currency.active + ' ' + productPrice;

    if (isProductComingSoon({ tags: item.tags })) {
      applyComingSoonWishlistCta(newElement);
    }

    //default option
    newElement.querySelector(`.select-selected span`).innerHTML = variantTitle;
    newElement.querySelector("[name='id']").value = variantID;
    newElement
      .querySelector(`.select-selected`)
      .addEventListener('click', function(e) {
        e.stopPropagation();
        this.classList.toggle('select-arrow-active');
        this.nextElementSibling.classList.toggle('select-hide');
      });

    //remove from grid if removed from wishlist
    newElement
      .querySelector('.smartwishlist')
      .addEventListener('click', function() {
        this.closest('.grid-item').remove();
      });


    document.querySelector('.wishlist-section .grid').appendChild(newElement);

    buildSizeDropdown(productID, variantID, variantTitle, item.variants);
    ReloadSmartWishlist();
  });
}

document.addEventListener('click', function(e) {
  const target = e.target.closest('.select-items > div'); // Or any other selector.

  if (target) {
    //set dropdown text
    target.closest('.select-items').previousElementSibling.innerHTML =
      `<span>${ target.innerHTML }</span>`;
    let x = target.closest('.custom-select').dataset.productId;
    document.querySelector(`[data-product-id='${ x }'].btn`).dataset.variantId =
      target.dataset.variant;
    document.querySelector(
      `[data-product-id='${ x }'].product-cta form input[name="id"] `
    ).value = target.dataset.variant;
    closeAllSelect(this);
  }
});

// Close all select boxes when the user clicks anywhere outside:
document.addEventListener('click', closeAllSelect);
